import { IconButton, Stack, styled, Typography } from '@mui/material';
import { HeaderClient } from '../conponents/HeaderClient';
import { InputText } from 'app/components/elements/InputText';
import { useInjection } from './hook';
import React from 'react';
import { ButtonCustom } from 'app/components/elements/ButtonCustom';
import { StyledParams } from 'types/common';
import { useNavigate } from 'react-router-dom';
export const CreateClientPage = () => {
  const navigate = useNavigate();
  const {
    backToClient,
    handleSubmit,
    onCreateClient,
    register,
    errors,
    fileInputIconRef,
    handleFileChange,
    fileIcon,
    handleFileClick,
    handleDeleteLogo
  } = useInjection();
  return (
    <WrapperCreatePage>
      <HeaderClient
        onClickButton={backToClient}
        textButton={'Cancel'}
        title={'Add New Client'}
        paths={[
          { name: 'Clients', level: 999, onClick: () => navigate('/clients') },
          { name: 'Add New Client', level: 999, onClick: () => {} }
        ]}
      />
      <Stack alignItems={'center'} justifyContent={'space-between'} flexDirection={'row'}>
        <Stack alignItems={'flex-start'} gap={3.75} width={'100%'}>
          <Stack alignItems={'flex-start'} mt={1.5} gap={1}>
            <TextNormalStyled>Logo</TextNormalStyled>
            <Stack gap={0.75} alignItems={'flex-end'}>
              <input
                accept="image/*"
                ref={fileInputIconRef}
                hidden
                onChange={(event) => handleFileChange(event)}
                type="file"
              />
              {fileIcon && (
                <img
                  height={80}
                  style={{ objectFit: 'cover' }}
                  src={URL.createObjectURL(fileIcon)}
                  alt={'icon'}
                />
              )}
              {fileIcon ? (
                <IconButton onClick={handleDeleteLogo}>
                  <img alt={'icon-user'} src={'/icons/icon_delete.svg'} width={24} />
                </IconButton>
              ) : (
                <IconButton onClick={handleFileClick}>
                  <Stack
                    alignItems={'center'}
                    justifyContent={'center'}
                    bgcolor={'#D9D9D9'}
                    padding={1.8}
                    sx={{ cursor: 'pointer' }}>
                    <img alt={'icon-user'} src={'/icons/icon_logo_upload.svg'} width={53} />
                  </Stack>
                </IconButton>
              )}
            </Stack>
          </Stack>
          <Stack gap={'29px'} width={'100%'} maxWidth={'532px'}>
            <InputText
              title={'Client Name'}
              inputError={errors.clientName?.message}
              placeholder={'Client Name'}
              inputProps={{
                ...register('clientName')
              }}
            />
            <InputText
              title={'Client Email'}
              inputError={errors.clientEmail?.message}
              placeholder={'Client Email'}
              inputProps={{
                ...register('clientEmail')
              }}
            />
            <InputText
              inputError={errors.contactPerson?.message}
              title={'Contact Person'}
              placeholder={'Contact Person'}
              inputProps={{
                ...register('contactPerson')
              }}
            />
          </Stack>
          <Stack>
            <ButtonCustom
              onClick={handleSubmit(onCreateClient)}
              label={'Add New Client'}
              style={{ width: '370px' }}
            />
          </Stack>
        </Stack>
      </Stack>
    </WrapperCreatePage>
  );
};
const WrapperCreatePage = styled(Stack)(() => ({
  padding: '40px 30px 0 40px',
  width: '100%'
}));
const TextNormalStyled = styled(Typography)(({ theme }: StyledParams) => ({
  color: theme.colors.base,
  fontSize: '20px',
  fontWeight: 600,
  fontFamily: `'Avenir',sans-serif`
}));
